import uuid from "react-uuid";

import HWUser from "../Simplify360Chat/HWLibrary/HWUser";
import { s360ConfigService } from "../Simplify360Chat/Services/S360Config";

export const CometdActions = (cometdInstance) => {
  let sendURl = s360ConfigService?.config?.preview ? "/cometd-preview-channel" : "/cometd-server-channel";

  let subscription;
  const subscribe = (listenChannel, refElement) => {
    let recieveURL = `/${listenChannel}`;
    let listOfComponentsToUpdate = ["ConversationPage", "LandingPage"];

    const cometdSubscribe = () => {
      return cometdInstance.subscribe(
        recieveURL,
        function (message) {
          if (message) {
            let customEvent = new CustomEvent("updateComponent", {
              detail: {
                componentsToUpdate: listOfComponentsToUpdate,
                data: {
                  message,
                },
              },
              bubbles: true,
            });
            console.log("COMETD-LOG: EVENT TRIGGERED", message);
            refElement?.current?.dispatchEvent(customEvent);
            console.log("COMETD-LOG-CHECK: 1 service");
          }
        },
        function (ack) {
          if (ack.successful) {
            console.log("COMETD-LOG: RECIEVE CHANNEL SUBSCRIBED", refElement,"recieveChannel",recieveURL,"sendChannel",sendURl);
            localStorage.setItem("subscribed", "true");
          }
        }
      );
    }

    if (localStorage.getItem("subscribed")) {
      console.log("Subscription already exists.");
    } else {
      if (sessionStorage.getItem("subscription")) {
        cometdInstance.unsubscribe(JSON.parse(sessionStorage.getItem("subscription")));
      }
      subscription = cometdSubscribe();
      sessionStorage.setItem("subscription", JSON.stringify(subscription));
    }
  }

  //cometd subscribe

  const sendMessage = (sessionId, messageData, convoType) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const sourceId = HWUser.sourceId();
    const customerFirstName = HWUser.customerFirstName();
    const customerLastName = HWUser.customerLastName();
    const appId = HWUser.appId();
    console.log("messageData.id", messageData.id)
    const msgId = messageData.id;
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "CUSTOMER_REPLY",
      customerId,
      message: messageData,
      convoType: convoType,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      appId: appId,
      msgId: msgId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      creator: "CUSTOMER",
      firstMessageTimestamp: 0,
    };

    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CUSTOMER_REPLY", params);
      if (message) {
        return message;
      }
    });
  };

  const sendAckAgentMessage = (sessionId, messageData, convoType) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const sourceId = HWUser.sourceId();
    const customerFirstName = HWUser.customerFirstName();
    const customerLastName = HWUser.customerLastName();
    const appId = HWUser.appId();
    const msgId = messageData.msgId;
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "ACK_AGENT_REPLY",
      customerId,
      message: messageData,
      convoType: convoType,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      appId: appId,
      msgId: msgId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      creator: "CUSTOMER",
      firstMessageTimestamp: 0,
    };

    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE ACK AGENT REPLY", params);
      if (message) {
        return message;
      }
    });
  };

  const sendBotAckMessage = (sessionId, messageData, convoType) => {
    console.log("sendBotAckMessage", sessionId, messageData, convoType);
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const sourceId = HWUser.sourceId();
    const customerFirstName = HWUser.customerFirstName();
    const customerLastName = HWUser.customerLastName();
    const appId = HWUser.appId();
    const msgId = messageData.msgId;
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "ACK_BOT_REPLY",
      customerId,
      message: messageData,
      convoType: convoType,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      appId: appId,
      msgId: msgId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      creator: "CUSTOMER",
      firstMessageTimestamp: 0,
    };

    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE ACK AGENT REPLY", params);
      if (message) {
        return message;
      }
    });
  };

  const fetchConversations = (limit, lastFetchedSession) => {
    console.log("COMETD-LOG: IN FETCH CONVERSATIONS");
    const customerId = HWUser.customerId();
    const clientUser = HWUser.xmppUserName();
    const params = {
      configId: s360ConfigService.config.configId,
      command: "GET_SESSIONS_REQUEST",
      customerId,
      convoType: "TEXT",
      clientUser: !clientUser ? sessionStorage.getItem("cu") : clientUser ,
      fromUi: false,
      assignedTo: -1,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuid,
    };
    params["limit"] = limit || 30;
    params["sourceType"] = HWUser.sourceType() || 60;
    if (lastFetchedSession) {
      params["sessionInfo"] = lastFetchedSession;
    }

    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR GET_SESSION_REQUEST", params);
      if (message) {
        return message;
      }
    });
  };

  const fetchHistory = (sessionInfo, fromId, limit) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const params = {
      configId: s360ConfigService.config.configId,
      customerId,
      command: "HISTORY_REQUEST",
      convoType: "TEXT",
      fromUi: false,
      assignedTo: -1,
      firstMessageTimestamp: 0,
      sessionInfo,
      sourceType,
      isJabber: false,
      fromApi: false,
    };
    if (fromId) {
      params["fromId"] = fromId;
    }
    if (limit) {
      params["limit"] = limit;
    }
    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR HISTORY_REQUEST", params);
      if (message) {
        return message;
      }
    });
  };

  const createSession = () => {
    const customerId = HWUser.customerId();
    const clientUser = HWUser.xmppUserName();
    const sourceType = HWUser.sourceType() || 60;
    const params = {
      configId: s360ConfigService.config.configId,
      command: "CREATE_SESSION",
      customerId,
      convoType: "TEXT",
      clientUser,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
    };

    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CREATE_SESSION", params);
      if (message) {
        return message;
      }
    });
  };

  const saveUserMetaData = (userDetails, sessionId) => {
    const params = {
      sessionId: sessionId,
      command: "SAVE_USER_DETAILS",
      userDetails: userDetails,
      isJabber: false,
      fromApi: false,
    };
    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR SAVE_USER_DETAILS", params);
      if (message) {
        return message;
      }
    });
  };

  const closeSession = (sessionId) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const params = {
      configId: s360ConfigService.config.configId,
      sessionId: sessionId,
      command: "SESSION_CLOSE_REQUEST",
      customerId,
      convoType: "TEXT",
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuId: uuid(),
    };

    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CLOSE_SESSION", params);
      if (message) {
        return message;
      }
    });
  };

  const changeLanguage = (sessionId, language) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const params = {
      configId: s360ConfigService.config.configId,
      sessionId: sessionId,
      command: "CHANGE_LANGUAGE",
      customerId,
      changeLanguage: language,
      customerFirstName: s360ConfigService.config.configId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuId: uuid(),
      creator: "CUSTOMER",
    };
    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR LANGUAGE CHANGE", params);
      if (message) {
        return message;
      }
    });
  };

  const sendChatTranscript = (sessionInfo, emailId) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const params = {
      configId: s360ConfigService.config.configId,
      sessionInfo: sessionInfo,
      emailId,
      command: "SEND_CHAT_TRANSCRIPT_REQUEST",
      customerId,
      convoType: "TEXT",
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuId: uuid(),
    };
    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CHAT  TRANSCRIPT", params);
      if (message) {
        return message;
      }
    });
  };

  const healthPing = (sessionId) => {
    const customerId = HWUser.customerId();
    const clientUser = HWUser.xmppUserName();

    const params = {
      configId: s360ConfigService.config.configId,
      command: "HEALTH_PING",
      customerId,
      clientUser,
      fromUi: false,
      isJabber: false,
      fromApi: false,
      sessionId: sessionId,
      sourceType: HWUser.sourceType() || 60,
    };
    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR healthPing", params);
      if (message) {
        return message;
      }
    });
  };

  const sendGif = (sessionId, messageData, convoType) => {
    console.log(sessionId, "hello");
    const customerId = HWUser.customerId();
    const clientUser = HWUser.xmppUserName();
    const sourceType = HWUser.sourceType() || 60;
    const sourceId = HWUser.sourceId();
    const customerFirstName = HWUser.customerFirstName();
    // const customerLastName = HWUser.customerLastName();
    const pageName = HWUser.pageName();
    const appId = HWUser.appId();

    const params = {
      msgId: messageData.id,
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "CUSTOMER_REPLY",
      customerId: customerId,
      message: messageData,
      convoType: convoType,
      clientUser: clientUser,
      customerFirstName: customerFirstName,
      typing: false,
      appId: appId,
      fromUi: false,
      assignedTo: -4,
      pageName: pageName,
      firstMessageTimestamp: 0,
      sourceType: sourceType,
      isJabber: false,
      fromApi: false,
    };
    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CHAT sendGif ", params);
      if (message) {
        return message;
      }
    });
  };

  const sendTypingIndicatorMessage = (sessionId, isTyping) => {
    const customerId = HWUser.customerId();
    const sourceType = HWUser.sourceType() || 60;
    const sourceId = HWUser.sourceId();
    const customerFirstName = HWUser.customerFirstName();
    const customerLastName = HWUser.customerLastName();
    const appId = HWUser.appId();
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "TYPING_INDICATOR",
      customerId,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      appId: appId,
      sourceType,
      typer: "CUSTOMER",
      typing: isTyping
    };

    cometdInstance.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG: TYPING_INDICATOR ", params);
      if (message) {
        return message;
      }
    });
  };

  return {
    fetchConversationsCMD: fetchConversations,
    createSessionCMD: createSession,
    fetchHistoryCMD: fetchHistory,
    sendMessageCMD: sendMessage,
    saveUserMetaData: saveUserMetaData,
    closeSessionCMD: closeSession,
    changeLanguageCometd: changeLanguage,
    sendChatTranscriptCMD: sendChatTranscript,
    sendAckAgentMessage: sendAckAgentMessage,
    sendGif: sendGif,
    sendTypingIndicatorMessage: sendTypingIndicatorMessage,
    sendBotAckMessage: sendBotAckMessage,
    sendHealthPing: healthPing,
    subscribe: subscribe
  };
};
